import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import { PortalWrapper } from './PortalWrapper';
import { FilterCertificates } from './Filter';
import { Main } from './styles';

export const Portal = (): JSX.Element => {
  return (
    <>
      <Header />
      <Menu />
      <Main>
        <FilterCertificates />
        <PortalWrapper title="Portal do Conhecimento" />
      </Main>
    </>
  );
};
